import React from "react";

const NoPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center text-textPrimary p-6 bg-opacity-50 rounded-xl">
        <h1 className="text-9xl font-extrabold animate-pulse">404</h1>
        <p className="text-2xl font-semibold mt-4 text-textPrimary">Oops! Page not found</p>
        <p className="mt-4 text-lg text-textSecondary">
          The page you're looking for does not exist.
        </p>
        <div className="mt-6">
          <a
            href="/"
            className="px-8 py-3 text-lg font-medium text-white bg-primary rounded-full transition duration-300"
          >
            Go Back Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default NoPage;
